module.exports = __webpack_public_path__ + "img/38.6709ce46.jpg";